<template>
  <div id="app">
    <router-view/>
    <BackTop></BackTop>
  </div>
</template>

<script>
import { QuestionBasic_index, QuestionPoint_index } from "./assets/js/api.js";
export default {
  name: "App",
  data() {
    return {
      classmap: new Map()
    };
  },
  created() {
    // 针对提示框的全局配置
    this.$Notice.config({
      top: 100,
      duration: 3
    });
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
      if (
        this.$store.state.questiontype &&
        !this.$store.state.questiontype.length
      ) {
        this.gettype();
      }
      if (!this.$store.state.qplist.length) {
        this.getqp();
      }
    }
  },
  mounted() {
    this.gettype();
    this.getqp();
  },
  methods: {
    gettype() {
      QuestionBasic_index().then(res => {
        if (res && res.data.code == 200) {
          this.$store.commit("setquestiontype", this.rangedata(res.data.data));
          this.rangeclassmap(res.data.data);
          this.$store.commit("setclassmap", this.classmap);
        }
      });
    },
    getqp() {
      QuestionPoint_index().then(res => {
        if (res && res.data.code == 200) {
          this.$store.commit("setqplist", res.data.data);
        }
      });
    },
    rangedata(data) {
      // 所需数据格式
      // value: 'beijing',
      // label: '北京',
      // children: [
      //  {
      //    value: 'gugong',
      //    label: '故宫'
      //  },
      // ]
      if (data instanceof Array && data.length > 0) {
        data = data.map(item => {
          var t = {};
          t.value = item.qbid;
          t.label = item.qbtitle;
          if (item.child) {
            t.children = this.rangedata(item.child);
          }
          return t;
        });
        return data;
      } else {
        return;
      }
    },
    rangeclassmap(data) {
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.classmap.set(item.qbid, item.qbtitle);
          if (item.child) {
            this.rangeclassmap(item.child);
          }
        });
      } else {
        return null;
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "微软雅黑", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 1000px;
}
.contain {
  width: 11.6rem;
  margin: 0 auto;
}
.contain_main {
  width: 10.6rem;
  margin: 0 auto;
}
body,
ul,
ol,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
table,
td,
img,
div {
  margin: 0;
  padding: 0;
  border: 0;
}
body {
  background: #fff;
  color: #333;
  font-size: 0.16rem;
}
div {
  box-sizing: border-box;
}
input {
  border: none;
  outline: none;
}
ul,
ol {
  list-style-type: none;
}
select,
input,
img,
select {
  vertical-align: middle;
}

a {
  text-decoration: none;
}
a:link {
  color: #009;
}
a:visited {
  color: #800080;
}
a:hover,
a:active,
a:focus {
  color: rgb(136, 122, 122);
  text-decoration: underline;
}
.ivu-input-number-input {
  margin-top: -5px;
}
tbody tr {
  background: #f9fafc;
  height: 0.5rem !important;
}
tbody tr td {
  word-break: break-all;
  word-wrap: wrap;
}
.tableName {
  background: #dfeaff;
  color: #4c85ff;
  width: 150px;
  line-height: 30px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  padding: 0 10px;
}
.issue_question {
  background: #dfeaff;
  width: 250px;
  line-height: 30px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  padding: 0 10px;
}
.ivu-tooltip-inner {
  word-break: break-all !important;
  word-wrap: break-word !important;
  white-space: normal !important;
  width: 250px;
}
.ivu-notice-notice {
  background: #fadacd !important;
}
.ivu-radio-group-vertical .ivu-radio-wrapper {
  height: auto !important;
}
.button,
.back,
.close,
button,
.operate,
.buttom {
  cursor: pointer !important;
}
textarea.ivu-input {
  font-size: 12px;
}
.ivu-date-picker-rel .ivu-input[disabled] {
  border: 1px solid #dcdee2 !important;
  border-radius: 4px !important;
  color: #515a6e !important;
  background-color: #fff !important;
  cursor: pointer !important;
}
.ivu-progress-inner {
  background-color: #ccddff !important;
}
.ivu-progress-bg {
  background-color: #555bff !important;
  height: 8px !important;
}
.ivu-input-group {
  display: inline-block !important;
}
/* 富文本编辑的设置 */
/* .quill-editor .ql-toolbar{
  display: none;
}
.quill-editor:hover .ql-toolbar{
  display: block;
} */
.quill-editor .ql-container {
  border: 1px solid #ccc !important;
}
.choice .item img {
  max-width: 100% !important;
}
.title img {
  max-width: 100% !important;
}
.questiontitle img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue